import { render, staticRenderFns } from "./TeacherWorkRegime.vue?vue&type=template&id=dd615482"
import script from "./TeacherWorkRegime.vue?vue&type=script&lang=js"
export * from "./TeacherWorkRegime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd615482')) {
      api.createRecord('dd615482', component.options)
    } else {
      api.reload('dd615482', component.options)
    }
    module.hot.accept("./TeacherWorkRegime.vue?vue&type=template&id=dd615482", function () {
      api.rerender('dd615482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherWorkRegime.vue"
export default component.exports